import React, { Component } from "react";
import { Row, Col, Card, Table } from "reactstrap";
import CgnAlert from "../toolbox/CgnAlert";
import CgnLoader from "../toolbox/CgnLoader";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import { URL,  localFilePath } from "../../redux/actions/constants";

class ProductCountMachineGetDetail extends Component {
  state = {
    pageTitle: "Yetkili Sayım Detay",
    pageTitleDetail: "Yetkili Sayım Detay",
    pageAddLink: "sayim2-ekle",
    pageListLink: "yetkili-sayim2-listele",
    breadcrumb: [{ text: "Sayım", link: "#" }],
    isLoading: false,
    alertErrorMessage: "",
    locationName: "",
    locationGuid: null,
    productCountProductMachineDto: [],
    totalPiece: "",
    productName: "",
    piece: null,
    status: "",
    createdBy: "",
    createdAt: "",
    updatedAt: "",
    updatedByF: "",
  };


  async componentDidMount() {

    let urlSplit = window.location.pathname.split("/");
    if (urlSplit.length === 3) {
      this.setState({
        pageTitle: this.state.pageTitleDetail,
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var personGuid = localStorage.getItem("guid");
      axios
        .get(
          URL + "/productCountsmachine/getpersonel/" + urlSplit[2] + "/" + personGuid,
          config
        )
        .then((response) => {
          this.setState({
            productCountProductMachineDto: response.data.productCountProductMachineDto,
            locationName: response.data.locationName,
            locationGuid: response.data.locationGuid,
            status: response.data.status,
            totalPiece: response.data.totalPiece,
            createdBy: response.data.createdBy,
            createdAt: response.data.createdAt,
            updatedBy: response.data.updatedBy,
            updatedAt: response.data.updatedAt,
            isLoading: false,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    }
  }

  handlePrint = async () => {
    let urlSplit = window.location.pathname.split("/");
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    var personGuid = localStorage.getItem("guid");
    await axios
      .get(URL + "/productCountsmachine/getpersonelexcel/" + urlSplit[2] + "/" + personGuid, config)
      .then((response) => {
        var myData = response.data;
        let replaceLink = myData.replace(localFilePath, "");
        if (replaceLink) {
          window.open(replaceLink, "_blank");
          this.setState({
            isLoading: false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  };

  render() {
    const mainRow = {
      backgroundColor: "#1d4b8c",
      color: "#fff",
    };
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          listLink={"/" + this.state.pageListLink}
          excelLink={
            (onClick) => this.handlePrint()
          }
        />
        <Row>
          <Col>
            <Card body>
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title="Uyarı"
                  text={this.state.alertErrorMessage}
                />
              )}

              <Table className="table table-responsive table-hover">
                <tbody>
                  <tr>
                    <th>Depo</th>
                    <td colSpan="4">{this.state.locationName}</td>
                  </tr>
                  <tr>
                    <th>Ekleyen Kullanıcı</th>
                    <td colSpan="4">{this.state.createdBy}</td>
                  </tr>
                  <tr>
                    <th>Eklenen Tarih</th>
                    <td colSpan="4">{this.state.createdAt}</td>
                  </tr>
                </tbody>
              </Table>

              {this.state.productCountProductMachineDto !== null &&
                this.state.productCountProductMachineDto.length > 0 && (
                  <Table className="table table-responsive table-hover table-productCount">
                    <tr style={mainRow}>
                      <th>Ürün Adı</th>
                      <th className="text-center">Sağlam Adet</th>
                      <th className="text-center">Arızalı Adet</th>
                      <th className="text-center">Toplam Adet</th>
                      <th className="text-center">Stok Adet</th>
                      <th className="text-center">Fark</th>
                    </tr>
                    {this.state.productCountProductMachineDto.map(function (item) {
                      return (
                        <tr>
                          <td>{item.machineProductName}</td>
                          <td className="text-center">{item.pieceDurable}</td>
                          <td className="text-center">{item.pieceDefective}</td>
                          <td className="text-center">{item.piece}</td>
                          <td className="text-center">{item.productPieceStock}</td>
                          <td className="text-center">{item.productPieceStock - item.piece}</td>
                        </tr>
                      );
                    })}
                  </Table>
                )}
            </Card>
            <CgnButtonLink
              color="secondary"
              to={"/" + this.state.pageListLink}
              text="Geri"
              className="btn-back"
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default ProductCountMachineGetDetail;
